import React, { useEffect, useState } from 'react';
import { notificationsAPI } from '../api';
import { Star, X } from 'react-feather';
import './FeatureNotificationModal.css';

export default function FeatureNotificationModal() {
  const [notification, setNotification] = useState(null);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const res = await notificationsAPI.getNotifications();
      const unreadFeatures = res.data.notifications.filter(
        n => n.type === 'new_feature' && n.is_read === 0
      );
      if (unreadFeatures.length > 0) {
        setNotification(unreadFeatures[0]);
      }
    } catch (err) {
      console.error('Failed to load notifications', err);
    }
  };

  const handleClose = async () => {
    setClosing(true);
    try {
      await notificationsAPI.markAsRead(notification.id);
    } catch (err) {
      console.error('Failed to mark as read', err);
    }
    setTimeout(() => {
      setNotification(null);
      setClosing(false);
    }, 300);
  };

  if (!notification) return null;

  return (
    <div className={`feature-modal-overlay ${closing ? 'closing' : ''}`}>
      <div className="feature-modal-content">
        <button className="feature-modal-close" onClick={handleClose}>
          <X size={20} />
        </button>
        <div className="feature-modal-icon-wrap">
          <Star size={32} color="#fff" />
        </div>
        <h3 className="feature-modal-title">{notification.title}</h3>
        <p className="feature-modal-body">{notification.body}</p>
        <button className="btn btn-primary feature-modal-btn" onClick={handleClose}>
          Awesome, got it!
        </button>
      </div>
    </div>
  );
}
